import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../icon';

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const ControlIcon = styled(Icon)`
	opacity: 0.5;
	margin: 1.25rem 1.5rem;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

function MenuControls(props) {
	const {
		isMaximized,
		onMaximizeClick,
		onMinimizeClick
	} = props;

	const icon = isMaximized ? 'chevronLeft' : 'chevronRight';

	const handleClick = () => {
		isMaximized ? onMinimizeClick() : onMaximizeClick();
	};

	return (
		<Container>
			<ControlIcon
				use={icon}
				color="white"
				onClick={handleClick}
			/>
		</Container>
	);
}

MenuControls.propTypes = {
	isMaximized: PropTypes.bool,
	onMaximizeClick: PropTypes.func,
	onMinimizeClick: PropTypes.func
};

MenuControls.methodProps = [
	'onMaximizeClick',
	'onMinimizeClick'
];

export default MenuControls;
